var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can({ assessment: 'write' }))?_c('form-dialog',{attrs:{"name":"","icon":"person_add","steps":_vm.$filterByEntitlements(_vm.formSteps),"editable-company":"","large-btn":"","data-test":"createAccounts"},on:{"submit":_vm.create}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }